import DemoSection from '../DemoSection';
import { UIMessage } from '../WebComponents';

export default function MessageDemo() {
  return (
    <DemoSection title="Message 全局提示" description="全局展示操作反馈信息">
      <DemoSection.Item title="类型">
        <div className="demo-content">
          <UIMessage type="success">成功消息</UIMessage>
          <UIMessage type="error">错误消息</UIMessage>
          <UIMessage type="warning">警告消息</UIMessage>
          <UIMessage type="info">信息消息</UIMessage>
        </div>
        <div className="code-block">
          <code>{`<UIMessage type="success">成功消息</UIMessage>
<UIMessage type="error">错误消息</UIMessage>
<UIMessage type="warning">警告消息</UIMessage>
<UIMessage type="info">信息消息</UIMessage>`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
